/**
 * @file
 *  Responsive headers on tables js.
 */

(function (Drupal, once, basictable) {
  'use strict';

  Drupal.behaviors.tableResponsive = {
    attach: function (context) {
      once('table-responsive', 'table', context).forEach(function (table, index) {

        if (table.querySelectorAll('thead').length > 0) {
          const tableId = "basictable-" + index + Math.floor(Math.random() * 1000);
          table.classList.add("basictable", tableId);

          new basictable("." + tableId, {
            noResize: true
          });
        }
        else {
          table.classList.add('no-header');
        }

      });
    }
  };

})(Drupal, once, basictable);
